import { createContext, useContext, useEffect, useState } from "react";

const PermissionsContext = createContext();



export const PermissionsProvider = ({ children }) => {

    const [Permissions, setPermissionsState] = useState(() => {
        const stored = localStorage.getItem("permissions");
        return stored ? JSON.parse(stored) : [];
    })



    // save permissions to local storage on change from login page 
    useEffect(() => {
        localStorage.setItem("permissions", JSON.stringify(Permissions));
    }, [Permissions]);

    const setPermissions = (perms) => {
        setPermissionsState(perms);
    }

    return (
        <PermissionsContext.Provider value={{Permissions, setPermissions}}>
            {children}
        </PermissionsContext.Provider>
    );
};



export const usePermissions = () => {
    return useContext(PermissionsContext);
}


export default { usePermissions , PermissionsProvider};

